import CryptoJS from "crypto-js";

class ReactSecurityHelper {
  static APP_VERSION = "2.0.6";
  static DeviceId = "Clients-Portal-PDC";

  static getDeviceId() {
    return this.DeviceId;
  }

  /**
   * Generate random nonce
   * @returns {string} Base64 encoded nonce
   */
  static generateNonce() {
    return CryptoJS.lib.WordArray.random(16).toString(CryptoJS.enc.Base64);
  }

  /**
   * Create HMAC signature for API request
   * @param {string} method - HTTP method (GET, POST, etc.)
   * @param {string} path - API path with query string
   * @param {string} timestamp - ISO timestamp
   * @param {string} nonce - Random nonce
   * @param {string} deviceId - Device ID
   * @param {string} accessToken - Access Token for signature
   * @returns {string} Base64 encoded signature
   */
  static createSignature(timestamp, path, deviceId, method, nonce, accessToken) {
    const payloadParts = [
      timestamp,
      path.toUpperCase(),
      deviceId,
      method.toUpperCase(),
      nonce,
    ];

    const payload = payloadParts.join("");

    const signature = CryptoJS.HmacSHA256(payload, accessToken).toString(
      CryptoJS.enc.Base64,
    );

    return signature;
  }

  /**
   * Create security headers for API request
   * @param {string} method - HTTP method
   * @param {string} path - API path
   * @param {string} accessToken - Access Token for signature
   * @returns {Object} Security headers
   */
  static createHeaders(method, path, accessToken) {
    const timestamp = new Date().toISOString();
    const nonce = this.generateNonce();
    const deviceId = this.getDeviceId();

    // Extract path starting from /api for signature (domain-independent)
    let pathForSignature = path;
    const apiIndex = path.indexOf("/api");
    if (apiIndex !== -1) {
      pathForSignature = path.substring(apiIndex).toUpperCase();
    }

    const signature = this.createSignature(
      timestamp,
      pathForSignature,
      deviceId,
      method,
      nonce,
      accessToken,
    );

    return {
      "X-App-Timestamp": timestamp,
      "X-App-Signature": signature,
      "X-App-Nonce": nonce,
      "X-App-Device": deviceId,
      "X-App-Version": this.APP_VERSION,
    };
  }
}

export default ReactSecurityHelper;
